var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ColumnContent,
    { attrs: { title: _setup.title } },
    _vm._l(_setup.context.towns, function (town) {
      return _c(
        "a",
        {
          key: town.translit,
          staticClass: "d-table text--text link-decoration-none mb-4",
          class: {
            "text-body-1": !town.is_main_town,
            "text-subtitle-1": town.is_main_town,
          },
          attrs: {
            "data-qa": "town-link",
            href: _setup.reverseFullL10N({
              name: "town",
              args: { town_translit: town.translit, language: _setup.urlLang },
            }),
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.transDynamic(
                  town,
                  `name,${_setup.iso},${_setup.needTranslate}`
                )
              ) +
              "\n  "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }